export default __webpack_public_path__ + "static/media/logo-company-17.503cf21e.png";